import { model } from 'eco-cli'

export class Dict extends model.Model {
    key = ''
    value = ''

    type = ''
    extra = null

    static create(key, value, type, extra) {
        return Dict.new({ key, value, type, extra })
    }

    static new({ key, value, type, extra } = { key: -1, value: '', type: '', extra: null }) {
        const d = new Dict()
        d.key = (key || '').toString()
        d.value = (value || '').toString()
        d.type = (type || '').toString()
        d.extra = extra

        return d
    }


    static formOpiton(op) {
        return Dict.create(op.key, op.label)
    }

    toOption() {
        return { key: this.key, label: this.value }
    }
}

export class DictTree extends Dict {

    isLeaf = true
    children = []

    static create(key, value, type, extra, children) {
        return DictTree.new({ key, value, type, extra, children })
    }

    static new({ key, value, type, extra,children } = { key: -1, value: '', type: '', extra: null,children:[] }) {

        const d = new DictTree()
        d.key = (key || '').toString()
        d.value = (value || '').toString()
        d.type = (type || '').toString()
        d.children = children || []
        d.extra = extra

        return d
    }

    static formOpiton(op) {
        return DictTree.create(op.key, op.label)
    }

    static toOption(list){
        return list.map(v=>{
             if(v instanceof DictTree){
                return {
                    title: v.value,
                    value: v.key,
                    key: v.key,
                    dict: v,
                    children:DictTree.toOption(v.children)
                }
            }else if(v instanceof Dict){
                return {
                  title: v.value,
                  value: v.key,
                  key: v.key,
                  dict: v
                }
            }else{
                throw new Error('DictTree: type error!')
            }
        })
    }

    toOption() {
        return { key: this.key, label: this.value }
    }
}